<template>
    <div class="p-5">
        <div class="d-flex justify-content-between align-items-center mb-5">
            <div class="c-title">Distributions - <span v-if="campaign" v-text="campaign.title.length > 100 ? campaign.title.substr(0, 100) + '...' : campaign.title"></span> </div>
            <div class="ml-3 d-flex justify-content-between align-items-center">
                <button class="btn c-btn-add" @click="addItem" v-if="DibbleJS.isAllowedAccess(Authorizations.MODULE_NAMES.CAMPAIGN_DISTRIBUTION_ADD)">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
                <button @click="goBack" class="btn c-cancel-btn ml-2">Back</button>
            </div>
        </div>

        <div class="table-responsive">
            <table class="table">
                <thead class="c-thead">
                    <tr>
                        <th scope="col"
                            class="h-id"
                        >
                            ID
                        </th>
                        <th scope="col" class="h-title">Title</th>
                        <th scope="col" class="h-type">Type</th>
                        <th scope="col"
                            class="h-date"
                        >
                            Created On
                        </th>
                        <th scope="col"
                            class="h-amount text-right"
                        >
                            Amount
                        </th>
                        <th>Link</th>
                    </tr>
                </thead>
                <tbody v-if="distributions.length">
                    <DistributionTableItem
                        :types="distribution_types"
                        v-for="item in distributions"
                        :key="item.distribution_id"
                        :data="item"
                        @editItem="editItem"
                    />
                </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="6" class="text-center">No data</td>
                </tr>
              </tbody>
            </table>
            <modal-add-edit-distribution v-if="isShowModal"
                                        :campaign-id="campaign.campaign_id"
                                        :types="distribution_types"
                                        :data="modalData"
                                        @upload="showDistributionModal"
                                        @success="isShowModal = false; getDistributions();"
                                        @close="isShowModal = false" />
        </div>

        <ModalCampaignDistribution
            v-if="isShowModalDistribution"
            :data="distribution_form_data"
            :campaign_id="campaign.campaign_id"
            @set-distribution-data="setDistributionData"
            @distribution-data-errored="distributionDataErrored"
            @close="isShowModalDistribution = false"
        />

        <ModalCampaignDistributionErrored
            v-if="isShowModalDistributionErrored"
            @close="
                isShowModalDistributionErrored = false;
            "
        />

        <ModalCampaignDistributionSuccess
            v-if="isShowModalDistributionSuccess"
            @close="isShowModalDistributionSuccess = false"
        />

        <ModalCampaignDistributionProgress
            v-if="isShowModalDistributionProgress"
            :data="distributionData"
            @distribute-success="
                isShowModalDistributionProgress = false;
                isShowModalDistributionSuccess = true;
                getDistributions();
            "
            @distribute-error="
                isShowModalDistributionProgress = false;
                isShowModalDistributionErrored = true;
            "
            @close="isShowModalDistributionProgress = false"
        />
    </div>
</template>

<script>
import DibbleJs from '@/dibble';
import DibbleApi from '@/api';
import {EventBus} from "@/utils/event-bus";
import ModalCampaignDistributionProgress
    from "@/components/campaigns/components/ModalCampaignDistributionProgress.vue";
import ModalCampaignDistribution
    from "@/components/campaigns/components/ModalCampaignDistribution.vue";
import ModalCampaignDistributionErrored
    from "@/components/campaigns/components/ModalCampaignDistributionErrored.vue";
import ModalCampaignDistributionSuccess
    from "@/components/campaigns/components/ModalCampaignDistributionSuccess.vue";
import ModalAddEditDistribution
    from "@/components/campaigns/components/ModalAddEditDistribution.vue";
import DistributionTableItem
    from "@/components/campaigns/components/DistributionTableItem.vue";
import DibbleJS from "@/dibble";
import Authorizations from "@/utils/authorizations";

export default {
    name: 'CampaignDistributions',
    computed: {
        Authorizations() {
            return Authorizations
        },
        DibbleJS() {
            return DibbleJS
        }
    },
    components: {
        DistributionTableItem,
        ModalAddEditDistribution,
        ModalCampaignDistributionSuccess,
        ModalCampaignDistributionErrored,
        ModalCampaignDistribution,
        ModalCampaignDistributionProgress,
    },
    data() {
        return {
            search: '',
            campaign: null,
            distributions: [],
            distribution_types: [],
            displayCampaigns: [],
            isShowModal: false,
            modalData: null,

            distribution_form_data: null,
            distributionData: null,
            isShowModalDistribution: false,
            isShowModalDistributionErrored: false,
            isShowModalDistributionSuccess: false,
            isShowModalDistributionProgress: false,
        };
    },
    methods: {
        goBack() {
            this.$router.push({
                name: 'CampaignsView',
                params: {
                    id: this.$route.params.id,
                },
            });
        },
        getCampaign() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getCampaign,
                campaign_id: this.$route.params.id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.campaign = response;
                    this.getDistributions();
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        getDistributions() {
            DibbleJs.showLoader();
            const data = {
                '#request': DibbleApi.api.getDistributions,
                campaign_id: this.$route.params.id,
            };
            DibbleJs.callApiRequest(data, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.distributions = response.distributions;
                    for (let i in response.distribution_types) {
                        this.distribution_types.push({
                            value: i,
                            label: response.distribution_types[i],
                        });
                    }
                } else {
                    DibbleJs.toastErrorMessage(response.message);
                }
                DibbleJs.hideLoader();
            });
        },
        addItem() {
            this.modalData = null;
            this.isShowModal = true;
        },
        editItem(data) {
            this.modalData = data;
            this.isShowModal = true;
        },
        showDistributionModal(data) {
            this.distribution_form_data = data;
            this.isShowModal = false;
            this.isShowModalDistribution = true;
        },
        setDistributionData(data) {
            this.distributionData = data;
            this.isShowModalDistribution = false;
            this.isShowModalDistributionProgress = true;
        },
        distributionDataErrored() {
            this.isShowModalDistributionErrored = true;
        },
    },
    created() {
        this.getCampaign();
        EventBus.$on('searchDonations', (search) => {
            this.search = search;
            this.getDonations();
        });
    },
};
</script>

<style lang="scss" scoped>
.c-cancel-btn {
    border-radius: 20px;
    background: #d9d9d9;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
    font-size: 20px;
    font-weight: 700;
    width: 120px;
    color: #555e67;
    line-height: 140%;
}
.c-title {
    color: #2178ab;
    font-size: 22px;
    font-weight: 700;
}
.c-tab-list {
    border-radius: 20px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-btn-add {
    color: #fff;
    width: 61px;
    height: 47px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #2178ab;
    border-radius: 20px;
    font-size: 24px;
    box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
}
.c-thead {
    th {
        color: #41B8DC;
        font-size: 16px;
        font-weight: 600;
        line-height: 24px;

        &.h-id {
            width: 5%;
        }
        &.h-title {
            width: 35%;
        }
        &.h-type {
            width: auto;
        }
        &.h-date {
            width: 15%;
        }
        &.h-amount {
            width: auto;
        }
    }
}
</style>
